import SpecialtyContextElementRepository from '../domain/SpecialtyContextElementRepository';
import FirestoreSpecialtyContextElementRepository from './FirestoreSpecialtyContextElementRepository';

export const specialtyContextElementRepository: SpecialtyContextElementRepository =
  new FirestoreSpecialtyContextElementRepository();
